import { Editor, Element, Transforms } from 'slate';

export const unwrapLink = (editor: Editor, { typeLink }: { typeLink: string }) =>
  Transforms.unwrapNodes(editor, { match: (n) => Element.isElement(n) && n.type === typeLink });
